import WonderType from "@/roc/wonders/base/WonderType";
import WonderKind from "@/roc/wonders/base/WonderKind";
import WonderOwner from "@/roc/wonders/base/WonderOwner";
import Effects from '@/roc/effects/Effects';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import Synergy from '@/roc/wonders/base/Synergy';
import EraType from '@/roc/era/EraType';

const Tikal = {
  id: '61',
  name: 'Tikal',
  era: EraType.earlyRome,
  icon: 'tikal',
  gameId: 'Tikal',
  minLevel: 1,
  maxLevel: 30,
  type: WonderType.GREAT_EMPIRE,
  kind: WonderKind.ARENA,
  kindMultiplier: 1,
  owner: WonderOwner.MAYA,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.MAYA_PRODUCTION_MOD,
      EffectAmount.asPerLevel([
        10,
        13,
        15,
        16.5,
        18,   // 5
        19.5,
        20.5,
        22.0,
        23.0,
        24.0, // 10
        24.5,
        25.5,
        26.5,
        27,
        28,   // 15
        28.5,
        29,
        30,
        30.5,
        31, // 20
        31.5,
        32.5,
        33,
        33.5,
        34,   // 25
        34.5,
        35,
        35.5,
        36,
        36.5  // 30
      ]),
      '%',
    ),
    new PassiveAura(
      PassiveAuraType.CAPITAL_CITY_GOODS_PRODUCTION_MOD,
      EffectAmount.asPerLevel([
        5,
        6.5,
        7.5,
        8.2,
        9.0,   // 5
        9.7,
        10.2,
        11.0,
        11.5,
        12.0, // 10
        12.2,
        12.7,
        13.2,
        13.5,
        14,   // 15
        14.2,
        14.5,
        15,
        15.3,
        15.5, // 20
        15.7,
        16.2,
        16.5,
        16.7,
        17,   // 25
        17.2,
        17.5,
        17.7,
        18,
        18.2  // 30
      ]),
      '%',
    ),
  ]),
  synergies: [
    {
      effectIndex: 1,
      mod: Synergy.asFlat(5).withKind(WonderKind.ARENA),
      effect: null,
    }
  ],
};

export default Tikal;
